import { render, staticRenderFns } from "./SoftwareContracts.vue?vue&type=template&id=460e8265&"
import script from "./SoftwareContracts.vue?vue&type=script&lang=js&"
export * from "./SoftwareContracts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports